module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "ded"
    }
  }), _vm._v("This book in the series is dedicated to the concept of redemption—that if we simply believe, we still have a fighting chance. Much has happened in the world since this series began. There are signs everywhere that we might all need to take heed and pursue a more spiritual path. The earth even stopped in time for microseconds after a disastrous tsunami. This tells me that there is a power out there greater than my tiny human brain could ever hope to conceive of, and therefore, anything is possible. But one thing I know for sure is redemption was a promise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("May you choose wisely and pause to think about things greater than we can fathom.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0